import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { CurrencyFormatPipe } from '@core/pipes/currency-format.pipe';
import { DateFormatPipe } from '@core/pipes/date-format.pipe';
import { AlertService } from '@core/services/alert.service';
import { CommonService } from '@core/services/common.service';
import { CorrespondenceService } from '@core/services/correspondence.service';
import { DataService } from '@core/services/data.service';
import { PolicyService } from '@core/services/policy.service';
import { TranslateService } from '@ngx-translate/core';
import { UserRole } from '@shared/models/codebooks/user-role';
import { CpcPayment } from '@shared/models/cpc-payment';
import { PolicyDetailComponent } from '../policy-detail.component';
import { LoadingService } from '@core/services/loading.service';
import { LOB } from '@shared/models/LOB';

@Component({
    selector: 'app-policy-detail-legal-person',
    templateUrl: './policy-detail-legal-person.component.html',
    styleUrls: ['./policy-detail-legal-person.component.scss'],
    standalone: false
})
export class PolicyDetailLegalPersonComponent extends PolicyDetailComponent implements OnInit {

    public showPayments = true;
    public showMaInsurance = false;
    public LOB = new LOB();

    constructor(
        public commonService: CommonService,
        protected dataService: DataService,
        protected policyService: PolicyService,
        protected route: ActivatedRoute,
        protected correspondenceService: CorrespondenceService,
        protected translateService: TranslateService,
        protected alertService: AlertService,

        private dateFormatPipe: DateFormatPipe,
        private currencyFormatPipe: CurrencyFormatPipe,

        public router: Router,
        protected loadingService: LoadingService
    ) {
        super(commonService, dataService, policyService, route, correspondenceService, translateService, alertService, loadingService);

    }

    ngOnInit(): void {
        super.ngOnInit();


            this.policyService.getPolicyDetail(this.policyState ,this.policyNumber).subscribe(res => {
                this.policy = res.policy;
                this.maInsurance = res.maInsurance;

                // filter upcoming premiums
                this.upcomingPremiumList = res.premiumList.list.filter(x => !x.matchDate)
                    .sort((a, b) => new Date(a.maturityDate).getTime() - new Date(b.maturityDate).getTime());

                this.pastPremiumList = res.premiumList.list.filter(x => !!x.matchDate)
                    .sort((a, b) => new Date(b.maturityDate).getTime() - new Date(a.maturityDate).getTime());

                this.downLoadDocumentUrl = this.dataService.environmentConfig.downloadDocumentUrl;

                this.loadDocuments();
                if (this.policy.downloadAllStatus != null && this.policy.downloadAllStatus.status == 'in-progress') {
                    this.CheckStatus();
                }


                if (this.upcomingPremiumList.length) {
                    this.upcomingPaymentList = this.upcomingPremiumList.map(premium => {
                        let o = {
                            variant: premium.status,
                            badgeVariant: this.paymentStatusVariant[premium.status],
                            due: this.dateFormatPipe.transform(premium.maturityDate),
                            amount: this.currencyFormatPipe.transform(premium.amount.toString(), premium.currency),
                            gatewayPaymentUrl: premium.gatewayPaymentUrl,
                            canBePayed: premium.canBePayed
                        }

                        this.translateService.get('payment-status').subscribe(t => {
                            if (t[premium.status])
                                o['variant'] = t[premium.status];
                        });

                        return o as CpcPayment;
                    });

                }

                if (this.pastPremiumList.length) {
                    this.pastPaymentList = this.pastPremiumList.map(premium => {
                        let o = {
                            variant: premium.status,
                            badgeVariant: this.paymentStatusVariant[premium.status],
                            due: this.dateFormatPipe.transform(premium.maturityDate),
                            date: this.dateFormatPipe.transform(premium.matchDate),
                            amount: this.currencyFormatPipe.transform(premium.amount.toString(), premium.currency),
                            method: '',
                        }

                        this.translateService.get('payment-status').subscribe(t => {
                            if (t[premium.status])
                                o['variant'] = t[premium.status];
                        });

                        this.translateService.get(this.paymentSources.findById(premium.paymentMethodId)?.textToTranslate).subscribe(t => {
                            o.method = t
                        })

                        return o as CpcPayment;
                    });
                }

                if ((this.policy.detailTypeIdentifier.toLowerCase() == this.lob.CarInsurance && this.policy.leasFleetFlag == true)
                    || (this.upcomingPaymentList.length == 0 && this.pastPaymentList.length == 0 && this.loggedUser.role == UserRole.LegalPerson)) {
                    this.showPayments = false;
                }

                // if (this.maInsurance !== null && (this.maInsurance.detailTypeIdentifier == 'CAR-INSURANCE' ||
                //     (this.maInsurance.detailTypeIdentifier == 'TRAVEL-INSURANCE' && this.loggedUser.role == UserRole.LegalPerson
                //         && this.maInsurance.tariffList != undefined && this.maInsurance.tariffList.length > 0))
                // ) {
                //     this.showMaInsurance = true;
                // }


            });

    }

    // TODO Remove ?
    paymentsTabChanged($event): void { }

    insuredTripsRedir() {
        this.router.navigate(['poistene-cesty'], {
            relativeTo: this.route
        });
    }

    employeesRedir() {
        this.router.navigate(['zamestnanci'], {
            relativeTo: this.route
        });
    }
}
